import React from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

const RatingStars = ({ rating = 0, setRating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    // const full = i <= Math.floor(rating);
    // const half = i > Math.floor(rating) && i - rating < 1;
    const full = i <= Math.floor(rating);
    const half = i > Math.floor(rating) && i - rating < 1;
    const color= rating <=3 && rating >0 ? "#E91515"
    :rating===0 ? "#D1D1D1": "#FFC107"


    
    stars.push(
      <span
        key={i}
        onClick={() => setRating?.(i)} // only clickable if setRating is passed
        style={{ cursor: setRating ? "pointer" : "default", marginRight: "4px" }}
      >
        {full ? (
          <FaStar color={color} fontSize={24} />
        ) : half ? (
          <FaStarHalfAlt color={color} fontSize={24} />
        ) : (
          <FaRegStar color={color} fontSize={24} />
        )}
      </span>
    );
  }

  return <span>{stars}</span>;
};

export default RatingStars;
